/* qm-article.js — Quirky Moose guide article v2 (sections/qm-article.liquid), 29/9-2026.
   1) copies the article's first product card into the right column (computers), and keeps its live price in step;
   2) marks the heading being read in the table of contents; closes the phone list after a jump;
   3) «Share»: the phone's share sheet, else copies the link;
   4) tables: gives each cell its column name, so phones can show every row as a small card.
   No dependencies. Nothing here moves the text column: the right column is its own grid column. */
(function () {
  'use strict';

  var CARD = 'div[style*="border-radius:14px;padding:18px;margin:28px 0"]';

  function text(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }

  function sized(src, w) {
    if (!src) return src;
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1' + w);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function buildCard(src, slot) {
    var img = src.querySelector('img');
    var info = src.querySelector(':scope > div');
    if (!info) return;
    var eyebrow = info.querySelector(':scope > div');
    var name = info.querySelector(':scope > a');
    var desc = info.querySelector(':scope > p');
    var row = info.querySelector(':scope > div:last-child');
    var price = row ? row.querySelector('span') : null;
    var btn = row ? row.querySelector('a') : null;
    var href = (name && name.getAttribute('href')) || (btn && btn.getAttribute('href'));
    if (!href) return;

    var media = document.createElement('a');
    media.className = 'qm-art__ac-media';
    media.href = href;
    media.tabIndex = -1;
    media.setAttribute('aria-hidden', 'true');
    if (img) {
      var im = document.createElement('img');
      im.src = sized(img.getAttribute('src'), 480);
      im.alt = '';
      im.width = 168;
      im.height = 168;
      im.loading = 'lazy';
      media.appendChild(im);
    }

    var body = document.createElement('div');
    body.className = 'qm-art__ac-body';
    if (eyebrow && eyebrow !== row) {
      var e = document.createElement('p');
      e.className = 'qm-col__eyebrow';
      e.textContent = text(eyebrow);
      body.appendChild(e);
    }
    var n = document.createElement('a');
    n.className = 'qm-art__ac-name';
    n.href = href;
    n.textContent = text(name) || text(btn);
    body.appendChild(n);
    if (desc) {
      var d = document.createElement('p');
      d.className = 'qm-art__ac-desc';
      d.textContent = text(desc);
      body.appendChild(d);
    }
    var r = document.createElement('div');
    r.className = 'qm-art__ac-row';
    if (price) {
      var p = document.createElement('span');
      p.className = 'qm-art__ac-price';
      p.textContent = text(price);
      r.appendChild(p);
      /* the article's own script fills in the live price later; follow it */
      if ('MutationObserver' in window) {
        new MutationObserver(function () { p.textContent = text(price); })
          .observe(price, { childList: true, characterData: true, subtree: true });
      }
    }
    if (btn) {
      var l = document.createElement('a');
      l.className = 'qm-art__ac-link';
      l.href = btn.getAttribute('href') || href;
      l.textContent = text(btn);
      r.appendChild(l);
    }
    body.appendChild(r);

    slot.appendChild(media);
    slot.appendChild(body);
    slot.hidden = false;
  }

  function tocSpy(root) {
    var links = Array.prototype.slice.call(root.querySelectorAll('.qm-art__toc [data-qm-toc]'));
    if (!links.length) return;
    var heads = links.map(function (a) { return document.getElementById(a.getAttribute('data-qm-toc')); });
    var current = null;
    var ticking = false;
    function update() {
      ticking = false;
      var id = null;
      for (var i = 0; i < heads.length; i++) {
        if (heads[i] && heads[i].getBoundingClientRect().top <= 160) id = links[i].getAttribute('data-qm-toc');
      }
      if (!id) id = links[0].getAttribute('data-qm-toc');
      if (id === current) return;
      current = id;
      links.forEach(function (a) {
        var on = a.getAttribute('data-qm-toc') === id;
        a.classList.toggle('is-active', on);
        if (on) {
          a.setAttribute('aria-current', 'true');
          /* a long list scrolls inside the column: keep the current line in sight (the page itself never moves) */
          var li = a.parentNode, list = li.parentNode;
          if (list.scrollHeight > list.clientHeight + 1) {
            var lr = list.getBoundingClientRect(), ar = li.getBoundingClientRect();
            if (ar.top < lr.top) list.scrollTop -= lr.top - ar.top;
            else if (ar.bottom > lr.bottom) list.scrollTop += ar.bottom - lr.bottom;
          }
        } else a.removeAttribute('aria-current');
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function share(root) {
    var btn = root.querySelector('[data-qm-share]');
    if (!btn) return;
    var label = btn.querySelector('[data-qm-share-label]');
    var orig = label ? label.textContent : '';
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-url');
      var title = btn.getAttribute('data-title');
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          if (!label) return;
          label.textContent = btn.getAttribute('data-done') || orig;
          setTimeout(function () { label.textContent = orig; }, 2200);
        }).catch(function () {});
      }
    });
  }

  function tables(body) {
    Array.prototype.forEach.call(body.querySelectorAll('table'), function (t) {
      var ths = t.querySelectorAll('thead th');
      if (!ths.length) return;
      var names = Array.prototype.map.call(ths, text);
      Array.prototype.forEach.call(t.querySelectorAll('tbody tr'), function (tr) {
        Array.prototype.forEach.call(tr.children, function (td, i) {
          if (names[i]) td.setAttribute('data-label', names[i]);
        });
      });
      t.classList.add('qm-art__tbl');
    });
  }

  function init(root) {
    if (!root || root.hasAttribute('data-qm-ready')) return;
    root.setAttribute('data-qm-ready', '');
    var body = root.querySelector('.qm-art__body');
    var slot = root.querySelector('[data-qm-art-card]');
    if (body && slot) {
      var src = body.querySelector('.qm-art__introcard') || body.querySelector(CARD);
      if (src) { try { buildCard(src, slot); } catch (err) {} }
    }
    tocSpy(root);
    share(root);
    if (body) tables(body);
    /* a jump from the folded list on phones closes it first, then jumps — so the list folding up above the
       heading cannot push the heading out of place */
    Array.prototype.forEach.call(root.querySelectorAll('.qm-art__toc-m a[href^="#"]'), function (a) {
      a.addEventListener('click', function (e) {
        var d = a.closest('details');
        var id = a.getAttribute('href').slice(1);
        var t = document.getElementById(id);
        if (!d || !t) return;
        e.preventDefault();
        d.open = false;
        t.scrollIntoView({ block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });
  }

  function boot() { document.querySelectorAll('[data-qm-art]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
